import Vue from "vue";
import Filters from './filters'
import './assets/style/common.scss'



/* ------------------------Vue Global Config-------------------------------- */
Vue.config.productionTip = false

/* ------------------------过滤器------------------------------ */
for (let key in Filters) {
  Vue.filter(key, Filters[key])
}

/* ------------------------公共插件/方法--------------------------------------- */
import './helper/axios'
import utils from './helper/utils'
import VueLocalStorage from 'vue-localstorage'
import _ from 'lodash';
Vue.prototype._ = _;
Vue.use(VueLocalStorage)
Vue.prototype.$utils = utils

import Print from './helper/print'
Vue.use(Print); // 注册

/* ------------------------全局组件------------------------------ */
import './components/element'
import './components/element-variables.scss'
import "./assets/style/elementUiChange.scss";
import "./assets/style/page.scss";
